import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { AMRDetail } from "../APIs/APIUrls";
import logo from '../images/logo/AMRWhiteLogo.png'

const allowedRoutes = [
  /^\/$/,
  /^\/home$/,
  /^\/[^/]+$/,
  /^\/property-details\/[^/]+$/,
  /^\/contact-us$/,
  /^\/privacy-policy$/,
  /^\/about-us$/,
  /^\/our-services$/,
  /^\/author\/[^/]+$/,
  /^\/blog-grid$/,
  /^\/blog-detail\/[^/]+$/,
];

const OrganizationSchema = () => {
  const { pathname } = useLocation();
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(true);

  const shouldRenderSchema = allowedRoutes.some((pattern) => pattern.test(pathname));

  useEffect(() => {
    const fetchAMRDetail = async () => {
      try {
        const cached = localStorage.getItem("amrDetailData");
        if (cached) {
          setDetail(JSON.parse(cached));
          setLoading(false);
          return;
        }

        const response = await fetch(`${AMRDetail}GetAMRDetailByIdforweb?Id=1`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {
          const result = await response.json();
          if (result.isSuccess && result.data) {
            setDetail(result.data);
            localStorage.setItem("amrDetailData", JSON.stringify(result.data));
          }
        }
      } catch (error) {
        console.error("Error fetching AMR detail:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAMRDetail();
  }, []);

  if (!shouldRenderSchema || pathname === "/404" || loading) {
    return null;
  }

  const detailData = detail || {};
  const description =
    detailData.ShortDescription ||
    "Trusted Real Estate Property Portal in India offering end-to-end solutions for buying, selling, and renting residential and commercial properties in Delhi NCR with verified listings and expert guidance.";
  const streetAddress = detailData.Address || "Delhi NCR";
  const telephone = detailData.ContactNo || "+91-XXXXXXXXXX";
  const email = detailData.Email || "info@askmerealty.in";
  const socialUrls = [
    detailData.Facebook,
    detailData.Instagram,
    detailData.Twitter,
    detailData.Youtube,
  ].filter(Boolean);

  const schema = {
    "@context": "https://schema.org",
    "@type": "RealEstateAgent",
    name: "AskMe Realty",
    alternateName: "AskMeReality",
    url: "https://askmerealty.in/",
    logo: "https://askmerealty.in/"+logo,
    description,
    address: {
      "@type": "PostalAddress",
      streetAddress,
      addressLocality: "Delhi NCR",
      addressCountry: "IN",
    },
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "customer service",
      telephone,
      email,
      availableLanguage: ["English", "Hindi"],
    },
    sameAs: socialUrls,
    knowsAbout: [
      "Real Estate",
      "Property Management",
      "Property Investment",
      "Home Buying",
      "Property Rental",
    ],
    areaServed: {
      "@type": "City",
      name: "Delhi NCR",
    },
    priceRange: "₹₹",
  };

  return (
    <Helmet>
      <script id="organization-schema" type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

export default OrganizationSchema;
